(function ($) {
    $(function () {
        // Remove "row" class from LearnDash elements to fix conflict with
        // Bootstrap CSS.
        $('.ld-course-list-items').removeClass('row');
    });
})(jQuery);
